import { useMemo } from "react";

import { Ship } from "components/icons/generated";
import useSelfServiceFlags from "hooks/useSelfServiceFlags";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useShipInfraGroup = (): MainNavigationItem => {
  const { enableSelfServiceV2 } = useSelfServiceFlags();

  return useMemo(
    () => ({
      id: "ship-infra",
      title: "Ship Infra",
      icon: Ship,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Stacks],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Resources],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Runs],
            ...(enableSelfServiceV2
              ? [
                  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[
                    MainNavigationPrimaryMenuItemKeys.TemplatesMarketplace
                  ],
                ]
              : []),
          ],
        },
      ],
    }),
    [enableSelfServiceV2]
  );
};

export default useShipInfraGroup;
